import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f2cdac4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/notification/_notification.scss?vue&type=style&index=0&id=2f2cdac4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2cdac4",
  null
  
)

export default component.exports